import { Popover } from '@thanx/uikit/popover'
import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import { useState } from 'react'

import Badge from 'components/Badge'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import { generateId } from 'utilities/uniqueId'

const t = buildTranslate('components.ai.picker.canonical')

type Props = {
  isSpecific: boolean
}

/**
 * Names a level's mode in a small pill; what the mode means shows on hover
 * or focus, and is the pill's description for screen readers.
 */
const SourceModePill = ({ isSpecific }: Props) => {
  const [css] = useStyletron()
  const [descriptionId] = useState(() => `source-mode-${generateId()}`)
  const mode = isSpecific ? 'specific' : 'smart'
  const colors = isSpecific
    ? { backgroundColor: palette.eggYolk10, color: palette.eggYolk80 }
    : { backgroundColor: palette.spearmint10, color: palette.spearmint90 }

  return (
    <>
      <Popover
        triggerType="hover"
        placement="top"
        content={
          <div className="p-s">
            <Text.BodyText5 color="grey70">
              {t(`${mode}.description`)}
            </Text.BodyText5>
          </div>
        }
      >
        <span
          role="img"
          tabIndex={0}
          aria-label={t(`${mode}.label`)}
          aria-describedby={descriptionId}
          className="d-inline-flex"
        >
          <Badge
            value={t(`${mode}.label`)}
            className={`text-nowrap ${css(colors)}`}
          />
        </span>
      </Popover>
      <span id={descriptionId} hidden>
        {t(`${mode}.description`)}
      </span>
    </>
  )
}

export default SourceModePill
